import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Form, Input, notification, Popover, Row, Select, Space, Spin, Table } from 'antd'
import _, { sum } from 'lodash'
import moment from 'moment'
import React, { ReactElement, useContext, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import styles from './unexecutedPrescription.module.css'
import { ThemeContext } from '../../../../theme/ThemeContext'
import { ListItem } from './listItem'
import { FilterIconOutlined } from '../../../../compnents/icons/Icons'
import { DateRangeType, DateSelect, getDateRange } from '../../../../compnents/form/DateSelect'
import { PatientDetailMessage } from './patientDetailMessage'
import { RecipeListItem } from './recipeListItem'
import { getMedicalRecipeDetail, getPatientDataList } from './unexecutedPrescriptionSlice'
import { DateTimeFormat, DateTimeFormatSimple, DateTimeFormatSimpleOnly } from '../../../../models/datetime'
import { CloseOutlined } from '@ant-design/icons'

export const UnexecutedPrescription = (props: {
  patientId?: string
  selectTabKey?: string
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const { Option } = Select

  const [form] = Form.useForm()

  const [popoverForm] = Form.useForm()

  const [open, setOpen] = useState(false)

  const [detail, setDetail] = useState<any>({})

  const [patientList, setPatientList] = useState<any[]>([])

  const [selectId, setSelectId] = useState<any>()

  const [registrationId, setRegistrationId] = useState<any>()

  const [head, tail] = getDateRange(DateRangeType.Today)

  const getFormatTime = (time: any) => {
    return moment(time).format(DateTimeFormatSimpleOnly)
  }

  const getFormatTimes = (time: any) => {
    return moment(time).format(DateTimeFormatSimple)
  }

  const getDateTimeFormat = (time: any) => {
    return moment(time).format(DateTimeFormat)
  }

  const [params, setParams] = useState<any>({
    startTime: getFormatTimes(head),
    endTime: getFormatTimes(tail),
  })

  const [pageLoading, setPageLoading] = useState(false) // 表格 loading

  const [rightDataList, setRightDataList] = useState<any[]>([])

  // 获取左侧患者列表
  const getLeftPatientList = (tag?: boolean) => {
    dispatch(getPatientDataList({
      ...params,
      state: 0,
      current: 1,
      size: 30,
      startTime: undefined,
      endTime: undefined,
      timeHead: params?.startTime ? getDateTimeFormat(params.startTime) : getDateTimeFormat(head),
      timeTail: params?.endTime ? getDateTimeFormat(params.endTime) : getDateTimeFormat(tail),
    }))
      .then(unwrapResult)
      .then((res: any) => {
        if (res?.records?.length) {
          setPatientList(res.records)
        } else {
          resetData()
          setPageLoading(false)
        }
      })
      .catch(() => {
        setPageLoading(false)
      })
  }

  useEffect(() => {
    if (registrationId) {
      getRightContent()
    }
  }, [registrationId])

  useEffect(() => {
    if (patientList?.length) {
      const flag = patientList?.filter((item: any) => item?.id == selectId).length
      setDetail(flag ? detail : patientList[0])
      setSelectId(flag ? selectId : patientList[0]?.id)
      setRegistrationId(flag ? detail?.registrationId : patientList[0]?.registrationId)
    }
  }, [patientList, selectId])

  const getRightContent = () => {
    setPageLoading(true)
    dispatch(getMedicalRecipeDetail({
      state: 0,
      startTime: params?.startTime ? getFormatTime(params.startTime) : getFormatTime(head),
      endTime: params?.endTime ? getFormatTime(params.endTime) : getFormatTime(tail),
      registrationId: registrationId,
    }))
      .then(unwrapResult)
      .then((res: any) => {
        setRightDataList(res)
      })
      .catch(() => {
        // do nothing
      })
      .finally(() => {
        setPageLoading(false)
      })
  }

  useEffect(() => {
    if (props?.selectTabKey == '0') {
      resetData()
      setPageLoading(true)
      getLeftPatientList()
    }
  }, [params, props?.selectTabKey])

  const resetData = () => {
    setPatientList([])
    setRightDataList([])
    setDetail({})
    setSelectId('')
    setRegistrationId('')
  }

  return (
    <>
      <Col
        className={styles.peddingMedicalTreatmentContainer}
      >
        <Row className={styles.content} >
          {/* 左侧页面 */}
          <Col
            style={{ backgroundColor: theme.pn }}
            className={styles.leftContent}
          >
            {/* 查询 */}
            <Form
              form={form}
              onFinish={(val) => {
                setPageLoading(true)
                resetData()
                setParams({
                  ...params,
                  ...val,
                })
              }}>
              <Row style={{ marginBottom: 10, padding: '0 15px' }}>
                <Form.Item name='param' noStyle>
                  <Input
                    size='middle'
                    placeholder='患者姓名/手机号/病历号'
                    maxLength={20}
                    style={{ width: '196px' }}
                    allowClear
                    onChange={(() => {
                      form.submit()
                    })}
                  />
                </Form.Item>
                <Popover
                  visible={open}
                  overlayClassName={styles.formQueryPopover}
                  content={
                    <>
                      <Form
                        form={popoverForm}
                        onFinish={(val) => {
                          setPageLoading(true)
                          resetData()
                          setOpen(false)
                          setParams({
                            ...params,
                            ...val,
                            startTime: val?.timeHead ? val?.timeHead : getFormatTime(head),
                            endTime: val?.timeTail ? val?.timeTail : getFormatTime(tail),
                            timeHead: undefined,
                            timeTail: undefined,
                          })
                        }}
                      >
                        <div className={styles.filterItem}>
                          <div className={styles.filterTitle}>开单日期</div>
                          <Form.Item name='' noStyle>
                            <DateSelect
                              styleFlag={true}
                              placeholder='时间范围'
                              style={{ width: '100%' }}
                              initialValue={DateRangeType.Today}
                              labelPrefix=''
                              namePrefix='time'
                              allowClear={false}
                            />
                          </Form.Item>
                          <div className={styles.filterTitle}>用法</div>
                          <Form.Item name='useMethod' noStyle>
                            <Select
                              placeholder='药品用法'
                              style={{ width: '100%' }}
                              allowClear
                              onChange={(() => {
                                return
                              })}
                            >
                              <Select.Option value='静滴'>静滴</Select.Option>
                              <Select.Option value='肌注'>肌注</Select.Option>
                              <Select.Option value='雾化'>雾化</Select.Option>
                              <Select.Option value='静推'>静推</Select.Option>
                              <Select.Option value='静注'>静注</Select.Option>
                              <Select.Option value='穴注'>穴注</Select.Option>
                              <Select.Option value='皮下'>皮下</Select.Option>
                            </Select>
                          </Form.Item>
                          <div className={styles.filterTitle}>结算状态</div>
                          <Form.Item name='settlementStatus' noStyle>
                            <Select
                              placeholder='结算状态'
                              style={{ width: '100%' }}
                              allowClear
                              onChange={(() => {
                                return
                              })}
                            >
                              <Select.Option value='0'>待收费</Select.Option>
                              <Select.Option value='3'>已收费</Select.Option>
                            </Select>
                          </Form.Item>
                        </div>
                        <Space
                          style={{
                            display: 'flex',
                            justifyContent: 'end',
                            marginTop: '10px',
                          }}
                        >
                          <Button
                            size='middle'
                            type={'ghost'}
                            onClick={() => {
                              popoverForm.resetFields()
                              setOpen(false)
                              setParams({
                                ...params,
                                startTime: getFormatTime(head),
                                endTime: getFormatTime(tail),
                              })
                            }}
                          >
                            取消
                          </Button>
                          <Button size='middle' type='primary' htmlType='submit'>
                            确定
                          </Button>
                        </Space>
                      </Form>
                    </>
                  }
                  title=''
                  trigger='click'
                  placement='bottom'
                  onVisibleChange={(v) => {
                    setOpen(v)
                  }}
                >
                  <Form.Item name='' initialValue={'筛选'} noStyle>
                    <Button
                      style={{
                        color: theme.tc2,
                      }}
                      className={styles.filterButton}
                      icon={
                        <FilterIconOutlined
                          className={styles.filterIcon}
                        />
                      }
                      onClick={() => {
                        setOpen(true)
                      }}
                    >
                      筛选
                    </Button>
                  </Form.Item>
                </Popover>
              </Row>
            </Form>
            <div style={{ marginBottom: '10px' }}>
              <div className={styles.filterText}>
                <span className={styles.leftText}>开单日期：{getFormatTimes(params?.startTime)} ~ {getFormatTimes(params?.endTime)}</span>
                <span
                  onClick={() => {
                    setParams({
                      ...params,
                      startTime: getFormatTimes(head),
                      endTime: getFormatTimes(tail),
                    })
                    popoverForm.setFieldsValue({
                      _dateRange: DateRangeType.Today,
                      timeHead: head,
                      timeTail: tail,
                    })
                  }}>
                  <CloseOutlined></CloseOutlined>
                </span>
              </div>
              {params?.useMethod &&
                <div className={styles.filterText}>
                  <span className={styles.leftText}>用法：{params?.useMethod}</span>
                  <span
                    onClick={() => {
                      setParams({
                        ...params,
                        useMethod: null,
                      })
                      popoverForm.setFieldsValue({
                        useMethod: null,
                      })
                    }}>
                    <CloseOutlined></CloseOutlined>
                  </span>
                </div>}
              {params?.settlementStatus && <div className={styles.filterText}>
                <span className={styles.leftText}>结算状态：{params?.settlementStatus == '0' ? '待收费' : params?.settlementStatus == '3' ? '已收费' : ''}</span>
                <span
                  onClick={() => {
                    setParams({
                      ...params,
                      settlementStatus: null,
                    })
                    popoverForm.setFieldsValue({
                      settlementStatus: null,
                    })
                  }}>
                  <CloseOutlined></CloseOutlined>
                </span>
              </div>}
            </div>
            {/* 展示患者信息 */}
            <div className={styles.listContent}>

              {patientList?.length !== 0 &&
                patientList.map((el: any, index: number) => (
                  <ListItem
                    selectId={selectId}
                    data={el}
                    key={el.id}
                    onClick={(el) => {
                      setSelectId(el?.id)
                      setRegistrationId(el?.registrationId)
                      setDetail(el)
                    }}
                  />
                ))}
            </div>
          </Col>
          <Col
            style={{ backgroundColor: theme.pn }}
            className={styles.rightContent}
          >
            {/* 展示患者详情 */}
            <PatientDetailMessage
              detail={detail}
            ></PatientDetailMessage>
            <div className={styles.recipelistItemBottoMain}>
              <RecipeListItem
                loading={pageLoading}
                patientId={detail?.patientId}
                selectTabKey={props?.selectTabKey}
                data={rightDataList}
                refresh={(() => {
                  setRegistrationId(null)
                  getLeftPatientList()
                })}
              />
            </div>
          </Col>
        </Row>
      </Col>
    </>
  )
}
